import { Component } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment.development';
import { DeliveryShiprocketService } from '../../services/delivery-shiprocket.service';

@Component({
  selector: 'app-order-cancelled',
  templateUrl: './order-cancelled.component.html',
  styleUrl: './order-cancelled.component.scss'
})
export class OrderCancelledComponent {
  trackDetails: any;
  track: any;
  trackProductImageUrl = environment.ImageBaseUrl;
 constructor(private api:ApiServiceService ,private activeRouter:ActivatedRoute, private router:Router ,private deliveryApi:DeliveryShiprocketService){
    this.activeRouter.params.subscribe((orderId : any)=>{
      const id = orderId['id'];
      this.getOrderById(id)
    })
  }
  
  ngOnInit(){
    this.trackingOrder()
  }

  getOrderById(id: any){
    this.api.getOrderById(id).subscribe((res: any)=>{
      this.trackDetails = res.orderDetails.orders_products[0];
    })
}


getProductById(id: any){
  this.router.navigate(["product-details", id])
  }





trackingOrder(){
  const para ={
    awb : 19041604839965,
  }
  this.deliveryApi.trackingOrder(para.awb).subscribe((res: any)=>{

  })
}


}


// }
